import { memo } from 'react';
import { Position, EmojiStatus } from '../../utils/types';
import EmojiComponent from './EmojiComponent';
import ExpirationPulse from './ExpirationPulse';

interface MemoizedEmojiProps {
  id: string;
  position: Position;
  status: EmojiStatus;
  emoji: string;
  ufoType: 'basic' | 'armored' | 'stealth';
  onTap: (e: React.TouchEvent | React.MouseEvent, id: string) => void;
  isExpiringSoon?: boolean;
}

const MemoizedEmoji = memo(
  ({ id, position, status, emoji, ufoType, onTap, isExpiringSoon = false }: MemoizedEmojiProps) => {
    return (
      <>
        <ExpirationPulse 
          isVisible={isExpiringSoon && status === 'captured'}
          position={{ x: position.x, y: position.y }}
        />
        <EmojiComponent
          id={id}
          position={position}
          status={status}
          emoji={emoji}
          ufoType={ufoType}
          onTap={(e) => onTap(e, id)}
        />
      </>
    );
  },
  (prev, next) => {
    return (
      prev.position.x === next.position.x &&
      prev.position.y === next.position.y &&
      prev.position.rotation === next.position.rotation &&
      prev.status === next.status &&
      prev.emoji === next.emoji &&
      prev.ufoType === next.ufoType &&
      prev.isExpiringSoon === next.isExpiringSoon
    );
  }
);

MemoizedEmoji.displayName = 'MemoizedEmoji';

export default MemoizedEmoji; 